import React from 'react';

import { ReactComponent as Calendar } from 'assets/icons/automatic-buy-calendar.svg';

const TransferInstructionContent = () => {
  return {
    title: "Transfer investments to T. Rowe Price",
    subtitle: `To fund your brokerage account, you can bring cash, securities, and CDs from your old firm to T. Rowe Price.`,
    steps: [
      {
        content: "Provide your account details for the external financial institution"
      },
      {
        content: "Decide which asset types and how much you'd like to transfer"
      }
    ],
    notes: [{
      content: "Transfers may take 7-10 business days. Once your sweep account is funded, you will be able to purchase shares of brokerage investments.",
      icon: <Calendar />
    }]
  }
};

export default TransferInstructionContent;
